import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { ConfigurationProfileStoreActions, ConfigurationProfileStoreStates } from '../configuration-profile';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class ConfigurationProfileResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly configurationProfileStore: Store<ConfigurationProfileStoreStates.ConfigurationProfileState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.configurationProfileStore.dispatch(
          ConfigurationProfileStoreActions.ConfigurationProfileResolverActions.configurationProfilesRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
